import styled, { css } from 'styled-components/macro'
import Box from 'components/shared/Box'
import { Color } from 'styles/types'
import { Spacing } from 'styles/spacing'

interface ListItemProps {
    backgroundColor?: Color
    gap?: Spacing
    isBulletCentered?: boolean
}

const defaultBulletGap = 12

export const ListItem = styled(Box)<ListItemProps>`
    align-items: flex-start;

    ::before {
        content: '';
        background: ${({ theme, backgroundColor }) =>
            backgroundColor
                ? theme.colors[backgroundColor]
                : theme.colors.secondary_500};
        min-width: 4px;
        max-height: 4px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        display: inline;
        margin-top: 8px;
        ${({ isBulletCentered, gap }) =>
            isBulletCentered
                ? css`
                      margin-left: 9px;
                      margin-right: 9px;
                  `
                : css`
                      margin-right: ${gap || defaultBulletGap}px;
                  `}
    }
`
